import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import BirthDateSelect from '../BirthDateSelect';

// ----------------------------------------------------------------------
// Wrapper de react-hook-form sobre BirthDateSelect (el selector Día/Mes/Año
// compartido). Guarda el valor del campo como string 'YYYY-MM-DD', igual que
// el viejo <input type="date">, para no tocar validación ni backend.

RHFBirthDate.propTypes = {
  name: PropTypes.string,
  fieldSx: PropTypes.object,
  futureYears: PropTypes.number, // años hacia el futuro (p.ej. fecha de boda)
};

export default function RHFBirthDate({ name, fieldSx, futureYears = 0 }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <BirthDateSelect
          value={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          error={!!error}
          helperText={error?.message}
          fieldSx={fieldSx}
          futureYears={futureYears}
        />
      )}
    />
  );
}
